// @ts-nocheck
import business from "./business.json";
import menu from "./menu.json";

/**
 * Everything the app shows: Piceri Hira's details and its menu.
 *
 * There is no API and no store - this is a static digital menu, so what is bundled
 * with the build is what the guest reads. Both files were taken verbatim from the
 * live API on 2026-08-10, unedited, so the shape every component reads is unchanged:
 *
 *   business.json  GET /api/v1/business/data/3
 *   menu.json      GET /api/menu-item/business/3   (12 categories, 167 items)
 *
 * To change a dish, a price or a phone number, edit the JSON and redeploy. Photos are
 * absolute URLs on api.clickapp.win; where an item has none, MenuImage draws a placeholder
 * rather than a broken image.
 *
 * They were on clickapp.win until that hostname was taken over by a Cloudflare Worker, which
 * answers /uploads/* with its own HTML page instead of the file. The files themselves never
 * moved - api.clickapp.win exposes the same /var/www/uploads directory through nginx.
 */

export const BUSINESS = business;
export const MENU = menu;
